import { getheader, serverUrl } from "./CommonFunctions";
export function getAllProvinces(){
    return dispatch =>{
        dispatch({
            type:"LOADING",
            data:true
        })
        fetch(serverUrl+"ProvinceAPI/SelectAllProvince",{
            headers:getheader()
        })
            .then(res=>res.json())
            .then(res=> 
            {
                dispatch({
                    type:"LOADING",
                    data:false
                })
                return dispatch(
                    {
                        type:"FETCH_DATA_PROVINCE", 
                        data:res
                    })
            }).catch(err=> {
                console.error('[FETCH_DATA_PROVINCE_LIST]', err);
                dispatch({
                    type:"LOADING",
                    data:false
                })
            })
            
        }
}
export function getCityList(provinceID)
{
    return dispatch =>{
        fetch(serverUrl + "CityAPI/SelectByIdCity?ProvinceId="+provinceID,{
            headers:getheader()
        })
        .then(res => res.json())
        .then(res=>{
            dispatch({
                type:"FETCH_DATA_CITY_LIST",
                data: res
            })
        }).catch(err=>{
            console.log("[FETCH_DATA_CITY_LIST]", err);
        })
    }
} 
export function getZoneList(cityID)
{
    return dispatch =>{
        fetch(serverUrl + "api/ZoneAPI/SelectZoneByCity?cityID=" + cityID,{
            headers:getheader()
        })
        .then(res=>  res.json())
        .then(res=>{
            dispatch(
                {
                    type:"FETCH_DATA_ZONE_LIST",
                    data:res
                }
            )
        }).catch(err=>{
                console.log("[FETCH_DATA_ZONE_LIST]",err);
            })
    }
}
export function setLocation(data)
{
    return dispatch =>{
       dispatch({ type:"SET_CURRENT_LOCATION",
        data:data
    })
    }
}